// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   MOBILE SCREENER FORM — Pill-based layout
   Scoped to viewports under 768px. Reuses tokens
   from MobileScreener.css and MobileScreenerHeatmap.css.
   Class prefix: msf-  (mobile screener form)
   ============================================ */

@media (max-width: 768px) {
  /* ============================================
     ROOT CONTAINER
     ============================================ */
  .msf-root {
    width: 100%;
    color: #ffffff;
    padding: 0 12px 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  /* ============================================
     FORM HEADER (Load preset button, right-aligned)
     ============================================ */
  .msf-form-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 4px;
  }

  .msf-load-preset-btn {
    background: #1a1a1a;
    border: 1px solid #333;
    border-radius: 999px;
    color: #b0b0b0;
    font-size: 12px;
    font-weight: 500;
    padding: 6px 12px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;
  }

  .msf-load-preset-btn:hover,
  .msf-load-preset-btn:focus {
    color: #218aff;
    border-color: #218aff;
    background: rgba(33, 138, 255, 0.1);
    outline: none;
  }

  .msf-load-preset-btn-icon {
    width: 14px;
    height: 14px;
  }

  /* ============================================
     SECTION
     ============================================ */
  .msf-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .msf-section-header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
  }

  .msf-section-title {
    font-size: 11px;
    font-weight: 600;
    color: #808080;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    line-height: 1.2;
    margin: 0;
  }

  .msf-section-meta {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }

  .msf-section-count {
    font-size: 11px;
    color: #808080;
    letter-spacing: 0.6px;
    text-transform: uppercase;
  }

  .msf-section-active {
    font-size: 11px;
    font-weight: 700;
    color: #218aff;
    letter-spacing: 0.6px;
    text-transform: uppercase;
  }

  .msf-section-clear {
    background: transparent;
    border: 1px solid #444;
    border-radius: 8px;
    color: #b0b0b0;
    font-size: 12px;
    font-weight: 500;
    padding: 4px 12px;
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .msf-section-clear:hover,
  .msf-section-clear:focus {
    color: #ffffff;
    border-color: #888;
    outline: none;
  }

  /* ============================================
     TICKER SECTION
     ============================================ */
  .msf-ticker-input-wrap {
    /* react-select renders inside; styles come from the component's
       customStyles prop. Just ensure it sits below the section header. */
  }

  /* ============================================
     DIRECTION CARD GRID
     ============================================ */
  .msf-direction-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .msf-direction-card {
    background: #1a1a1a;
    border: 1px solid #333;
    border-radius: 10px;
    padding: 14px 14px;
    text-align: left;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-height: 76px;
  }

  .msf-direction-card:hover {
    border-color: #555;
  }

  .msf-direction-card.msf-selected {
    background: rgba(33, 138, 255, 0.12);
    border-color: #218aff;
    box-shadow: 0 0 0 1px #218aff inset;
  }

  .msf-direction-title {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .msf-direction-card.msf-selected .msf-direction-title {
    color: #218aff;
  }

  .msf-direction-radio {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1.5px solid #555;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .msf-direction-card.msf-selected .msf-direction-radio {
    border-color: #218aff;
  }

  .msf-direction-card.msf-selected .msf-direction-radio::after {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #218aff;
  }

  .msf-direction-subtitle {
    font-size: 12px;
    color: #b0b0b0;
  }

  .msf-direction-warning {
    font-size: 11px;
    color: #f97316;
    margin-top: 2px;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  /* ============================================
     PILL ROW (Expiration, Strike, Strategy)
     Breaks out of the form's 12px gutter so the scroll track
     extends edge-to-edge with the viewport (Robinhood-style).
     First pill stays aligned with the section title via the
     inner padding-left.
     ============================================ */
  .msf-pill-row-wrap {
    position: relative;
    margin-left: -12px;
    margin-right: -12px;
  }

  .msf-pill-row {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x proximity;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: #333 transparent;
    padding: 0 12px 4px;
  }

  .msf-pill-row::-webkit-scrollbar {
    height: 4px;
  }

  .msf-pill-row::-webkit-scrollbar-track {
    background: transparent;
  }

  .msf-pill-row::-webkit-scrollbar-thumb {
    background: #333;
    border-radius: 2px;
  }

  /* Fade out indicator on right edge */
  .msf-pill-row-wrap::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 24px;
    background: linear-gradient(to left, #0a0a0a 0%, transparent 100%);
    pointer-events: none;
  }

  .msf-pill {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    background: #1f2937;
    border: 1px solid #2d3748;
    border-radius: 999px;
    color: #ffffff;
    font-size: 13px;
    font-weight: 500;
    padding: 8px 14px;
    min-height: 44px;
    cursor: pointer;
    transition: all 0.15s ease;
    flex-shrink: 0;
    scroll-snap-align: start;
    white-space: nowrap;
    text-align: left;
  }

  .msf-pill:hover {
    border-color: #555;
    color: #ffffff;
  }

  .msf-pill.msf-selected {
    background: #218aff;
    border-color: #218aff;
    color: #ffffff;
  }

  .msf-pill-label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    line-height: 1;
  }

  .msf-pill-sublabel {
    font-size: 11px;
    color: #cccccc;
    line-height: 1;
  }

  .msf-pill.msf-selected .msf-pill-sublabel {
    color: rgba(255, 255, 255, 0.85);
  }

  /* Strike row caption (← in the money | out of the money →) */
  .msf-strike-caption {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    color: #666;
    margin-top: 2px;
  }

  /* Strategy pill row needs a bit more height for sub-label */
  .msf-pill-strategy {
    flex-direction: column;
    min-height: 52px;
    padding: 8px 14px;
    align-items: flex-start;
  }

  /* ============================================
     MODE TOGGLE PILL (top of form: Basic / Intermediate)
     ============================================ */
  .msf-mode-toggle {
    display: inline-flex;
    align-self: flex-start;
    background: #141414;
    border: 1px solid #2a2a2a;
    border-radius: 999px;
    padding: 4px;
    gap: 0;
    margin-bottom: 4px;
  }

  .msf-mode-segment {
    appearance: none;
    background: transparent;
    border: none;
    color: #888;
    font-size: 13px;
    font-weight: 600;
    padding: 8px 18px;
    border-radius: 999px;
    cursor: pointer;
    transition: all 0.15s ease;
    min-height: 36px;
  }

  .msf-mode-segment:hover {
    color: #ffffff;
  }

  .msf-mode-segment.msf-selected {
    background: #218aff;
    color: #ffffff;
    box-shadow: 0 0 0 1px #218aff inset;
  }

  /* ============================================
     PRESET CARD GRID (Market Direction, Expiration Window)
     ============================================ */
  .msf-preset-card-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  /* When the grid has an odd number of children, the last one spans both columns */
  .msf-preset-card-grid > .msf-preset-card:last-child:nth-child(odd) {
    grid-column: 1 / -1;
  }

  .msf-preset-card {
    background: #1f2937;
    border: 1px solid #2d3748;
    border-radius: 12px;
    padding: 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
    cursor: pointer;
    transition: all 0.15s ease;
    min-height: 76px;
  }

  .msf-preset-card:hover {
    border-color: #555;
  }

  .msf-preset-card.msf-selected {
    background: #218aff;
    border-color: #218aff;
  }

  .msf-preset-card-title {
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
    display: inline-flex;
    align-items: center;
    gap: 0;
    line-height: 1.2;
  }

  .msf-preset-card.msf-selected .msf-preset-card-title {
    color: #ffffff;
  }

  .msf-preset-card-subtitle {
    font-size: 12px;
    color: #b0b0b0;
    font-weight: 400;
    line-height: 1.2;
  }

  .msf-preset-card.msf-selected .msf-preset-card-subtitle {
    color: rgba(255, 255, 255, 0.85);
  }

  /* ============================================
     ADD TO QUEUE CTA
     ============================================ */
  .msf-cta-wrap {
    padding-top: 4px;
  }

  .msf-cta {
    width: 100%;
    background: #2D7FF9;
    border: 1px solid #2D7FF9;
    border-radius: 12px;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    padding: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: all 0.15s ease;
    min-height: 52px;
    margin-bottom: 8px;
  }

  .msf-cta:hover:not(:disabled) {
    background: #1e6ce0;
    border-color: #1e6ce0;
  }

  .msf-cta:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Secondary (Add to queue) — outline-style under the primary Run button */
  .msf-cta.msf-cta-secondary {
    background: transparent;
    border: 1px solid #333;
    color: #ffffff;
  }

  .msf-cta.msf-cta-secondary:hover:not(:disabled) {
    border-color: #218aff;
    background: rgba(33, 138, 255, 0.1);
  }

  .msf-cta-icon {
    width: 16px;
    height: 16px;
  }

  .msf-cta-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #218aff;
    color: #ffffff;
    border-radius: 999px;
    padding: 2px 10px;
    font-size: 12px;
    font-weight: 600;
    min-width: 36px;
  }

  .msf-cta-hint {
    text-align: center;
    font-size: 11px;
    color: #666;
    margin-top: 6px;
    line-height: 1.4;
  }

  /* Save preset secondary button */
  .msf-save-btn {
    width: 100%;
    background: transparent;
    border: 1px solid #333;
    border-radius: 10px;
    color: #b0b0b0;
    font-size: 13px;
    font-weight: 500;
    padding: 10px;
    margin-top: 8px;
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .msf-save-btn:hover:not(:disabled) {
    color: #10b981;
    border-color: #10b981;
  }

  .msf-save-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  /* ============================================
     SLIDE-UP SHEET (Load Preset)
     Mirrors MobileScreenerHeatmap.css .mhm-sheet
     ============================================ */
  .msf-sheet-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1100;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.25s ease;
  }

  .msf-sheet-backdrop.msf-sheet-open {
    opacity: 1;
    pointer-events: auto;
  }

  .msf-sheet {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1101;
    background: #0f0f0f;
    border-top: 1px solid #333;
    border-radius: 16px 16px 0 0;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    transform: translateY(100%);
    transition: transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1);
    padding-bottom: env(safe-area-inset-bottom, 0);
  }

  .msf-sheet.msf-sheet-open {
    transform: translateY(0);
  }

  .msf-sheet-handle-bar {
    width: 40px;
    height: 4px;
    background: #444;
    border-radius: 2px;
    margin: 8px auto 4px;
    flex-shrink: 0;
  }

  .msf-sheet-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px 6px;
    border-bottom: 1px solid #222;
    flex-shrink: 0;
  }

  .msf-sheet-title {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
  }

  .msf-sheet-close {
    background: transparent;
    border: none;
    color: #888;
    font-size: 20px;
    cursor: pointer;
    padding: 4px 8px;
    line-height: 1;
  }

  .msf-sheet-close:hover {
    color: #ffffff;
  }

  .msf-sheet-body {
    overflow-y: auto;
    padding: 12px 12px 16px;
    flex: 1 1;
    min-height: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/MobileScreenerForm.css"],"names":[],"mappings":"AAAA;;;;;iDAKiD;;AAEjD;EACE;;mDAEiD;EACjD;IACE,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;;mDAEiD;EACjD;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;IACd,qBAAqB;IACrB,mCAAmC;IACnC,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;mDAEiD;EACjD;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;;IAEE,cAAc;IACd,kBAAkB;IAClB,aAAa;EACf;;EAEA;;mDAEiD;EACjD;IACE;yEACqE;EACvE;;EAEA;;mDAEiD;EACjD;IACE,aAAa;IACb,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,qBAAqB;IACrB,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;;;;;;mDAMiD;EACjD;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,iCAAiC;IACjC,qBAAqB;IACrB,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,qCAAqC;EACrC;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,WAAW;IACX,kEAAkE;IAClE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,cAAc;IACd,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA,6DAA6D;EAC7D;IACE,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA,4DAA4D;EAC5D;IACE,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;;mDAEiD;EACjD;IACE,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,YAAY;IACZ,MAAM;IACN,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,mCAAmC;EACrC;;EAEA;;mDAEiD;EACjD;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA,iFAAiF;EACjF;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,MAAM;IACN,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;mDAEiD;EACjD;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA,0EAA0E;EAC1E;IACE,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,mCAAmC;EACrC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA,iCAAiC;EACjC;IACE,WAAW;IACX,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;;mDAGiD;EACjD;IACE,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,0DAA0D;IAC1D,8CAA8C;EAChD;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,SAAO;IACP,aAAa;EACf;AACF","sourcesContent":["/* ============================================\n   MOBILE SCREENER FORM — Pill-based layout\n   Scoped to viewports under 768px. Reuses tokens\n   from MobileScreener.css and MobileScreenerHeatmap.css.\n   Class prefix: msf-  (mobile screener form)\n   ============================================ */\n\n@media (max-width: 768px) {\n  /* ============================================\n     ROOT CONTAINER\n     ============================================ */\n  .msf-root {\n    width: 100%;\n    color: #ffffff;\n    padding: 0 12px 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  /* ============================================\n     FORM HEADER (Load preset button, right-aligned)\n     ============================================ */\n  .msf-form-header {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n    padding-top: 4px;\n  }\n\n  .msf-load-preset-btn {\n    background: #1a1a1a;\n    border: 1px solid #333;\n    border-radius: 999px;\n    color: #b0b0b0;\n    font-size: 12px;\n    font-weight: 500;\n    padding: 6px 12px;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    white-space: nowrap;\n  }\n\n  .msf-load-preset-btn:hover,\n  .msf-load-preset-btn:focus {\n    color: #218aff;\n    border-color: #218aff;\n    background: rgba(33, 138, 255, 0.1);\n    outline: none;\n  }\n\n  .msf-load-preset-btn-icon {\n    width: 14px;\n    height: 14px;\n  }\n\n  /* ============================================\n     SECTION\n     ============================================ */\n  .msf-section {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .msf-section-header {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 10px;\n  }\n\n  .msf-section-title {\n    font-size: 11px;\n    font-weight: 600;\n    color: #808080;\n    letter-spacing: 0.6px;\n    text-transform: uppercase;\n    line-height: 1.2;\n    margin: 0;\n  }\n\n  .msf-section-meta {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n  }\n\n  .msf-section-count {\n    font-size: 11px;\n    color: #808080;\n    letter-spacing: 0.6px;\n    text-transform: uppercase;\n  }\n\n  .msf-section-active {\n    font-size: 11px;\n    font-weight: 700;\n    color: #218aff;\n    letter-spacing: 0.6px;\n    text-transform: uppercase;\n  }\n\n  .msf-section-clear {\n    background: transparent;\n    border: 1px solid #444;\n    border-radius: 8px;\n    color: #b0b0b0;\n    font-size: 12px;\n    font-weight: 500;\n    padding: 4px 12px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n  }\n\n  .msf-section-clear:hover,\n  .msf-section-clear:focus {\n    color: #ffffff;\n    border-color: #888;\n    outline: none;\n  }\n\n  /* ============================================\n     TICKER SECTION\n     ============================================ */\n  .msf-ticker-input-wrap {\n    /* react-select renders inside; styles come from the component's\n       customStyles prop. Just ensure it sits below the section header. */\n  }\n\n  /* ============================================\n     DIRECTION CARD GRID\n     ============================================ */\n  .msf-direction-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 8px;\n  }\n\n  .msf-direction-card {\n    background: #1a1a1a;\n    border: 1px solid #333;\n    border-radius: 10px;\n    padding: 14px 14px;\n    text-align: left;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-height: 76px;\n  }\n\n  .msf-direction-card:hover {\n    border-color: #555;\n  }\n\n  .msf-direction-card.msf-selected {\n    background: rgba(33, 138, 255, 0.12);\n    border-color: #218aff;\n    box-shadow: 0 0 0 1px #218aff inset;\n  }\n\n  .msf-direction-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  .msf-direction-card.msf-selected .msf-direction-title {\n    color: #218aff;\n  }\n\n  .msf-direction-radio {\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    border: 1.5px solid #555;\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .msf-direction-card.msf-selected .msf-direction-radio {\n    border-color: #218aff;\n  }\n\n  .msf-direction-card.msf-selected .msf-direction-radio::after {\n    content: '';\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #218aff;\n  }\n\n  .msf-direction-subtitle {\n    font-size: 12px;\n    color: #b0b0b0;\n  }\n\n  .msf-direction-warning {\n    font-size: 11px;\n    color: #f97316;\n    margin-top: 2px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  /* ============================================\n     PILL ROW (Expiration, Strike, Strategy)\n     Breaks out of the form's 12px gutter so the scroll track\n     extends edge-to-edge with the viewport (Robinhood-style).\n     First pill stays aligned with the section title via the\n     inner padding-left.\n     ============================================ */\n  .msf-pill-row-wrap {\n    position: relative;\n    margin-left: -12px;\n    margin-right: -12px;\n  }\n\n  .msf-pill-row {\n    display: flex;\n    gap: 8px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    scroll-snap-type: x proximity;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n    scrollbar-color: #333 transparent;\n    padding: 0 12px 4px;\n  }\n\n  .msf-pill-row::-webkit-scrollbar {\n    height: 4px;\n  }\n\n  .msf-pill-row::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  .msf-pill-row::-webkit-scrollbar-thumb {\n    background: #333;\n    border-radius: 2px;\n  }\n\n  /* Fade out indicator on right edge */\n  .msf-pill-row-wrap::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 24px;\n    background: linear-gradient(to left, #0a0a0a 0%, transparent 100%);\n    pointer-events: none;\n  }\n\n  .msf-pill {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n    background: #1f2937;\n    border: 1px solid #2d3748;\n    border-radius: 999px;\n    color: #ffffff;\n    font-size: 13px;\n    font-weight: 500;\n    padding: 8px 14px;\n    min-height: 44px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    flex-shrink: 0;\n    scroll-snap-align: start;\n    white-space: nowrap;\n    text-align: left;\n  }\n\n  .msf-pill:hover {\n    border-color: #555;\n    color: #ffffff;\n  }\n\n  .msf-pill.msf-selected {\n    background: #218aff;\n    border-color: #218aff;\n    color: #ffffff;\n  }\n\n  .msf-pill-label {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    line-height: 1;\n  }\n\n  .msf-pill-sublabel {\n    font-size: 11px;\n    color: #cccccc;\n    line-height: 1;\n  }\n\n  .msf-pill.msf-selected .msf-pill-sublabel {\n    color: rgba(255, 255, 255, 0.85);\n  }\n\n  /* Strike row caption (← in the money | out of the money →) */\n  .msf-strike-caption {\n    display: flex;\n    justify-content: space-between;\n    font-size: 11px;\n    color: #666;\n    margin-top: 2px;\n  }\n\n  /* Strategy pill row needs a bit more height for sub-label */\n  .msf-pill-strategy {\n    flex-direction: column;\n    min-height: 52px;\n    padding: 8px 14px;\n    align-items: flex-start;\n  }\n\n  /* ============================================\n     MODE TOGGLE PILL (top of form: Basic / Intermediate)\n     ============================================ */\n  .msf-mode-toggle {\n    display: inline-flex;\n    align-self: flex-start;\n    background: #141414;\n    border: 1px solid #2a2a2a;\n    border-radius: 999px;\n    padding: 4px;\n    gap: 0;\n    margin-bottom: 4px;\n  }\n\n  .msf-mode-segment {\n    appearance: none;\n    background: transparent;\n    border: none;\n    color: #888;\n    font-size: 13px;\n    font-weight: 600;\n    padding: 8px 18px;\n    border-radius: 999px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    min-height: 36px;\n  }\n\n  .msf-mode-segment:hover {\n    color: #ffffff;\n  }\n\n  .msf-mode-segment.msf-selected {\n    background: #218aff;\n    color: #ffffff;\n    box-shadow: 0 0 0 1px #218aff inset;\n  }\n\n  /* ============================================\n     PRESET CARD GRID (Market Direction, Expiration Window)\n     ============================================ */\n  .msf-preset-card-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n\n  /* When the grid has an odd number of children, the last one spans both columns */\n  .msf-preset-card-grid > .msf-preset-card:last-child:nth-child(odd) {\n    grid-column: 1 / -1;\n  }\n\n  .msf-preset-card {\n    background: #1f2937;\n    border: 1px solid #2d3748;\n    border-radius: 12px;\n    padding: 16px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    text-align: left;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    min-height: 76px;\n  }\n\n  .msf-preset-card:hover {\n    border-color: #555;\n  }\n\n  .msf-preset-card.msf-selected {\n    background: #218aff;\n    border-color: #218aff;\n  }\n\n  .msf-preset-card-title {\n    font-size: 15px;\n    font-weight: 600;\n    color: #ffffff;\n    display: inline-flex;\n    align-items: center;\n    gap: 0;\n    line-height: 1.2;\n  }\n\n  .msf-preset-card.msf-selected .msf-preset-card-title {\n    color: #ffffff;\n  }\n\n  .msf-preset-card-subtitle {\n    font-size: 12px;\n    color: #b0b0b0;\n    font-weight: 400;\n    line-height: 1.2;\n  }\n\n  .msf-preset-card.msf-selected .msf-preset-card-subtitle {\n    color: rgba(255, 255, 255, 0.85);\n  }\n\n  /* ============================================\n     ADD TO QUEUE CTA\n     ============================================ */\n  .msf-cta-wrap {\n    padding-top: 4px;\n  }\n\n  .msf-cta {\n    width: 100%;\n    background: #2D7FF9;\n    border: 1px solid #2D7FF9;\n    border-radius: 12px;\n    color: #ffffff;\n    font-size: 15px;\n    font-weight: 600;\n    padding: 14px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    transition: all 0.15s ease;\n    min-height: 52px;\n    margin-bottom: 8px;\n  }\n\n  .msf-cta:hover:not(:disabled) {\n    background: #1e6ce0;\n    border-color: #1e6ce0;\n  }\n\n  .msf-cta:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  /* Secondary (Add to queue) — outline-style under the primary Run button */\n  .msf-cta.msf-cta-secondary {\n    background: transparent;\n    border: 1px solid #333;\n    color: #ffffff;\n  }\n\n  .msf-cta.msf-cta-secondary:hover:not(:disabled) {\n    border-color: #218aff;\n    background: rgba(33, 138, 255, 0.1);\n  }\n\n  .msf-cta-icon {\n    width: 16px;\n    height: 16px;\n  }\n\n  .msf-cta-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: #218aff;\n    color: #ffffff;\n    border-radius: 999px;\n    padding: 2px 10px;\n    font-size: 12px;\n    font-weight: 600;\n    min-width: 36px;\n  }\n\n  .msf-cta-hint {\n    text-align: center;\n    font-size: 11px;\n    color: #666;\n    margin-top: 6px;\n    line-height: 1.4;\n  }\n\n  /* Save preset secondary button */\n  .msf-save-btn {\n    width: 100%;\n    background: transparent;\n    border: 1px solid #333;\n    border-radius: 10px;\n    color: #b0b0b0;\n    font-size: 13px;\n    font-weight: 500;\n    padding: 10px;\n    margin-top: 8px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n  }\n\n  .msf-save-btn:hover:not(:disabled) {\n    color: #10b981;\n    border-color: #10b981;\n  }\n\n  .msf-save-btn:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n  }\n\n  /* ============================================\n     SLIDE-UP SHEET (Load Preset)\n     Mirrors MobileScreenerHeatmap.css .mhm-sheet\n     ============================================ */\n  .msf-sheet-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.6);\n    z-index: 1100;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.25s ease;\n  }\n\n  .msf-sheet-backdrop.msf-sheet-open {\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .msf-sheet {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1101;\n    background: #0f0f0f;\n    border-top: 1px solid #333;\n    border-radius: 16px 16px 0 0;\n    max-height: 85vh;\n    display: flex;\n    flex-direction: column;\n    transform: translateY(100%);\n    transition: transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1);\n    padding-bottom: env(safe-area-inset-bottom, 0);\n  }\n\n  .msf-sheet.msf-sheet-open {\n    transform: translateY(0);\n  }\n\n  .msf-sheet-handle-bar {\n    width: 40px;\n    height: 4px;\n    background: #444;\n    border-radius: 2px;\n    margin: 8px auto 4px;\n    flex-shrink: 0;\n  }\n\n  .msf-sheet-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 16px 6px;\n    border-bottom: 1px solid #222;\n    flex-shrink: 0;\n  }\n\n  .msf-sheet-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #ffffff;\n  }\n\n  .msf-sheet-close {\n    background: transparent;\n    border: none;\n    color: #888;\n    font-size: 20px;\n    cursor: pointer;\n    padding: 4px 8px;\n    line-height: 1;\n  }\n\n  .msf-sheet-close:hover {\n    color: #ffffff;\n  }\n\n  .msf-sheet-body {\n    overflow-y: auto;\n    padding: 12px 12px 16px;\n    flex: 1;\n    min-height: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
